import { lazy } from 'react';

const ProductsPage = lazy(() => import('../pages/Products.page'));
const AddProductPage = lazy(() => import('../pages/AddProduct.page'));
const EditProductPage = lazy(() => import('../pages/EditProduct.page'));

const ProductsListRoutes = [
    {
        path: '/products',
        children: [
            { element: <ProductsPage />, layout: 'default', isAuthReq: true, index: true },
            {
                path: 'add',
                element: <AddProductPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'edit/:id',
                element: <EditProductPage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
];

export { ProductsListRoutes };
